import { ROUTE_NAMES } from '../constants/router';

export const getEventCardRoute = (id: number, isSystemEvent = false) => {
  return { name: ROUTE_NAMES.events.card, params: { id }, query: { isSystemEvent: String(isSystemEvent) } };
};
